module.exports = __webpack_public_path__ + "img/index-banner-1920x1080.eef9b34b.jpg";